<template>
  <loading v-if="loading" ></loading>
  <div class="main-div">
    <div class="drag-drop-upload" @dragover="handleDragOver" @dragleave="handleDragOver" @drop="handleFileSelect"
         @click="clickInput" :class="{'dragging' : dragging}">
      <label for="file-input" class="file-input" id="file-input-container">
        <div class="drag-title" v-if="!dragging && !results">
          <i class="far fa-upload d-block fa-3x mb-2"></i>
          فایل را برای آپلود به اینجا بکشید یا کلیک کنید
        </div>
        <slot name="dragging-container" v-if="dragging">
          فایل را اینجا رها کنید تا آپلود شود
        </slot>
        <input multiple id="file-input" type="file" @change="handleFileInput" ref="fileInput">
      </label>
      <div v-if="results" class="images">
        <div v-for="(result,index) in results" :key="index" class="image_items" :style="`background-image: url('${result.filePreview}')`">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwtInterceptor from "@/shared/jwtInterceptor";
import Loading from "@/components/Loading";
import {showSystemNoti} from "@/shared/helper";

export default {
name: "FileManagerUploadFiles",
  components: {Loading},
  data(){
    return{
      openFileManager:false,
      file_page_active : true,
      dragging : false,
      results  : null,
      apiUrl : process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH,
      loading : false,
    }
  },
  methods:{
    handleFileInput(event)
    {
      this.processFileInput(event.target.files);
      event.target.value = '';
    },
    handleDragOver(event)
    {
      event.stopPropagation();
      event.preventDefault();
      this.dragging = event.type === 'dragover';
      event.dataTransfer.dropEffect = 'copy';
    },
    handleFileSelect(event)
    {
      event.stopPropagation();
      event.preventDefault();
      this.dragging = false;
      this.processFileInput(event.dataTransfer.files);
    },
    async processFileInput(files)
    {
      this.loading = true;
      const apiUrl= this.apiUrl;
      this.results = null;
      if (files && files.length)
        await this.readFiles(files);
      else
      {
        this.loading= false;
        return showSystemNoti('danger','فایل معتبری دریافت نشد.')
      }
      const self = this;

        if (files && files.length)
        {
          let url = apiUrl + 'admin/Filemanager/Upload';
          let formData = new FormData();
          files = self.results;
          if (files && Array.isArray(files))
          {
            for (let i =0;i<files.length;i++)
            {
              if (files[i].file)
                formData.append('file', files[i].file);
            }
            const response = await jwtInterceptor.post(url,formData,{headers: {
                'Content-Type': 'multipartdddd/form-data'
              }});
            if (response && response.data)
            {
              const files =  response.data.files;
              self.$emit('filesUploaded',files);
            }
          }
          else
            showSystemNoti('danger','فایل معتبری دریافت نشد.')

        }
        else
          showSystemNoti('dander','فایل معتبری دریافت نشد.')
        self.loading = false;

    },
    clickInput()
    {
      this.$refs.fileInput.click();
    },
    async readFiles(files)
    {
      for (let i = 0; i < files.length; i++)
      {
        let file = files[i];
        if (file.type.match('image.*|audio.*|video.*')) {
          let reader = new FileReader();

          const readerOnload = new Promise((resolve, reject) =>
          {
            reader.onload = async function ()
            {
              if (this.results === null)
                this.results = [];
              const results = {
                filePreview: reader.result,
                file: file
              };
              this.results.push(results);
              resolve()
            }.bind(this);
          });
          await reader.readAsDataURL(file);
          await readerOnload;
        }
      }
    },
  }
}
</script>

<style scoped>
#file-input
{
  display: none;
}

.images
{
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap : wrap;
}
.images .image_items
{
  flex: 0 0 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin: 5px;
  border: 1px solid silver;
}
.main-div
{
  position: relative;
  margin: 15px;
}
.drag-drop-upload {
  width: 100%;
  height: 100%;
  min-height: 300px;
  max-height: max-content;
  border: 2px dashed #94A2AB;
  cursor: pointer;
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  z-index: 0;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}
.drag-drop-upload.dragging {
  background-color: #e2e8f0;
  border-color: #667eea;
}
.drag-drop-upload .file-input {
  height: 100%;
  pointer-events: none;
  margin-bottom: 0;
  font-size: 1.5rem;
  color: #718096;
  text-align: center;

}
</style>
